var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 33,
    viewBox: "0 0 37 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1-3h40v40H-1z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#80959D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.976 9.015H1.2v22.678h17.776V20.287M4.174 18.2h4.208M4.174 21.4h8.657M4.174 27.8h12.29M4.174 24.6h12.29"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.8 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "rgba(21, 87, 191, 0.7)",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 6,
    fill: "rgba(21, 87, 191, 0.7)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(21, 87, 191, 0.7)",
    strokeWidth: 0.8,
    d: "M15.2 18.385l2.593 2.763-.636.632 9.42 9.42 3.823-3.466-9.566-9.83-.885.816L17.48 16"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeo);
export default __webpack_public_path__ + "static/media/seo.b72e431caef29a29b8d2687d77cf44eb.svg";
export { ForwardRef as ReactComponent };